import api from "../utils/api";
import { isGuid } from "../utils/string";
import { send as sendEmail} from "./email.template";

import { LOGOUT } from "./types";

const DEFAULT_HOOK_ORIGIN = "https://api.matters3.feradel.com";

const normalizeRoot = (url) => {
    const value = String(url || "").trim().replace(/^['"]+|['";]+$/g, "").trim();
    if (!value) return DEFAULT_HOOK_ORIGIN;
    if (value.startsWith("/")) return window.location.origin;

    const rooted = /^https?:\/\//i.test(value)
        ? value
        : /^(localhost|127\.0\.0\.1|\[::1\])(?::|\/|$)/i.test(value)
            ? `http://${value}`
            : `https://${value}`;

    return rooted.replace(/\/+$/, "");
};

const mattersApiOrigin = () => normalizeRoot(localStorage.api)
    .replace(/\/api\/v1$/i, "")
    .replace(/\/api$/i, "");

const withHookOrigin = (payload = {}) => ({
    ...payload,
    hook: {
        ...(payload.hook || {}),
        origin: payload.hook?.origin || mattersApiOrigin()
    }
});

export const list = ({ flags=0, hidden=null }) => async (dispatch) => {
    try {
        const url = {
            base: "/surveys",
            path: "",
            compute: function () {
                return this.base + this.path;
            }
        }
        
        if ((flags ?? 0) > 0) url.path = `/f/${flags}`;
        if (hidden !== null) url.path = `/f/${flags}/h/${hidden}`;

        const res = await api.get(url.compute());
        return res.data?.items || [];
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return [];
    }
}

export const save = ({ uuid, name, description, hidden, system }) => async (dispatch) => {
    try {
        const res = await api.post(`/surveys`, { uuid, name, description, hidden, system });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/surveys/i/${uuid}`);
        return res.data.success ? res.data.items[0] : {};
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const builderDetail = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/surveys/builder/i/${uuid}`);
        return res.data?.item || {};
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const saveBuilder = (payload) => async (dispatch) => {
    try {
        const res = await api.post(`/surveys/builder`, withHookOrigin(payload));
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ( uuid ) => async (dispatch) => {
    try {
        const res = await api.delete(`/surveys/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const global = () => async (dispatch) => {
    try {
        const res = await api.get(`/surveys/g`);
        return res.data ?? [];
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const register = ({ uuid, parentUuid, domain, key, owner, version, published, name, description, meta }) => async (dispatch) => {
    try {
        const res = await api.post(`/surveys/r`, {uuid, parentUuid, domain, key, owner, version, published, name, description, meta});
        return res.data ?? {};
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const invites = ({ personUuid, surveyUuid }) => async (dispatch) => {
    try {
        const params = {
            findby: isGuid(personUuid) ? "person" : isGuid(surveyUuid) ? "survey" : null,
            uuid: isGuid(personUuid) ? personUuid : isGuid(surveyUuid) ? surveyUuid : null
        };
        const res = await api.get(`/surveys/invites/f/${params.findby}/i/${params.uuid}`);
        return res.data?.items ?? [];
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return [];
    }
}

export const invite = ({ personUuid, surveyUuid }) => async (dispatch) => {
    try {
        const res = await api.post(`/surveys/invites`, { surveyUuid, personUuid });
        if (!res?.data?.success) return {};
        await dispatch(sendEmail({ name: "INTAKE.INVITE", json: res.data, recipient: res.data.email }));
        return res.data ?? {};
    } catch (err) {
        console.log(err);
    }
}

export const uninvite = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/surveys/invites/i/${uuid}`);
        return res.data ?? {};
    } catch (err) {
        console.log(err);
    }
}

export const remind = ({ uuid, email, displayName }) => async (dispatch) => {
    try {
        const res = await api.get(`/surveys/invites/f/id/i/${uuid}`);
        if (!res?.data?.success) return {};
        const item = res.data.items[0];
        const data = {
            key: item.meta.key,
            uuid: item.uuid,
            name: item.Survey.name,
            description: item.Survey.description,
            flags: item.Survey.flags,
            version: item.Survey.version,
            email,
            displayName
        };

        await dispatch(sendEmail({name: "INTAKE.INVITE", json: data, recipient: data.email }));
        return res.data ?? {};
    } catch (err) {
        console.log(err);
    }
}
